
export default {
  props: {
    isLabel: {
      type: [Boolean, String],
      default: true
    },
    isSmall: {
      type: Boolean,
      default: false
    },
    isAllMode: {
      type: Boolean,
      default: false
    },
    /* 선택 된 개수/총개수 */
    isDivideMode: {
      type: Boolean,
      default: false
    },
    info: {
      type: String,
      default: ''
    },
    showCount: {
      type: Boolean,
      default: true
    },
    count: {
      type: [Number, String],
      default: null
    },
    total: {
      type: [Number, String],
      default: null
    }
  },
  computed: {
    formattedCount () {
      return this.count !== null ? this.count.toLocaleString() : ''
    },
    formattedTotal () {
      return this.total !== null ? this.total.toLocaleString() : ''
    }
  }
}
